
export default class PriceSaveCalculator {
  constructor(element) {
    this.el = element
    this.lakaMonth = this.el.dataset.price
    this.aKasse = this.el.querySelector("#akasse");
    this.yearOfBirth = this.el.querySelector("#yearofbirth");
    this.workload = this.el.querySelector("#workload");
    this.submit = this.el.querySelector("button");
    this.yearResult = this.el.querySelector("[data-yearresult]");
    this.totalResult = this.el.querySelector("[data-totalResult]");    
    this.generateAkasseList = this.generateAkasseList.bind(this);
    this.generateYearList = this.generateYearList.bind(this);
    this.generateResult = this.generateResult.bind(this);
    this.akassedata = this.el.querySelector("#akasser");
    this.date = new Date();
    this.subtractYears = this.subtractYears.bind(this);
    this.getYearsTillRetirement = this.getYearsTillRetirement.bind(this);
    this.isActiveAkasse = false;
    this.isActiveYear = false;
    this.init()
  }
  
  init() {
    const newDate = this.subtractYears(this.date, 18)
    //this.generateAkasseList();
    this.generateYearList(newDate.getFullYear())

    this.aKasse.addEventListener('change', e=>{
      if (this.aKasse.value != ""){
        this.isActiveAkasse = true;
        if (this.isActiveYear){
          this.submit.disabled = false;
        }
      }else{
        this.isActiveAkasse = false;
        this.submit.disabled = true;
      }
    })

    this.yearOfBirth.addEventListener('change', e =>{
      if (this.yearOfBirth.value != ""){
        this.isActiveYear = true;
        if (this.isActiveAkasse){
          this.submit.disabled = false;
        }
      }else{
        this.isActiveYear = false;
        this.submit.disabled = true;
      }
    })

    this.submit.addEventListener("click", e =>{
      this.generateResult(newDate.getFullYear());
    })
  }

  subtractYears(date, years){
    const dateCopy = new Date(date);
    dateCopy.setFullYear(date.getFullYear() - years);
    return dateCopy;
  }

  generateYearList(year){
    let years = `<option value="">Vælg dit fødselsår</option>` 
    for (var i = 1954; i <= year; i++){
      years = years + `<<option value="${i}">${i}</option>`
    }
    this.yearOfBirth.innerHTML = years;
  }

  generateAkasseList(){
    var json = JSON.parse(this.akassedata.textContent); 
    const akasser = json.map((akasse, index) =>{      
      return `
        ${index === 0?`
          <option value="">Vælg din nuværende a-kasse</option>
          <option value="${index}">${akasse.Name}</option>
        `:`
          <option value="${index}">${akasse.Name}</option>
        `}
      `
    }).join("");

    this.aKasse.innerHTML = akasser;
  }

    getYearsTillRetirement(choosenYear) {
    let retirementAge;

    if (choosenYear >= 1954 && choosenYear < 1955) {
      retirementAge = 66;
    }
    if (choosenYear >= 1955 && choosenYear < 1963) {
      retirementAge = 67;
    }
    if (choosenYear >= 1963 && choosenYear < 1967) {
      retirementAge = 68;
    }
    if (choosenYear >= 1967 && choosenYear < 1971) {
      retirementAge = 69;
    }
    if (choosenYear >= 1971 && choosenYear < 1975) {
      retirementAge = 70;
    }
    if (choosenYear >= 1975 && choosenYear < 1979) {
      retirementAge = 71;
    }
    if (choosenYear >= 1979 && choosenYear < 1987) {
      retirementAge = 72;
    }
    if (choosenYear >= 1987 && choosenYear < 1996) {
      retirementAge = 73;
    }
    if (choosenYear >= 1996) {
      retirementAge = 74;
    }

    let age = this.date.getFullYear() - choosenYear;
    let yearsTillRetirement = retirementAge - age;  

    if (yearsTillRetirement < 0) {
      yearsTillRetirement = 0
    }

    return yearsTillRetirement;
  }

  generateResult(){
    let choosenAkasse = this.aKasse.value;
    let choosenYear = this.yearOfBirth.value;
    let lakaYear = Number(this.lakaMonth) * 12
    let yearlyCost = Number(choosenAkasse) * 12;
    let yearlySavings = yearlyCost - lakaYear;
    
    const yearsTillRetirement = this.getYearsTillRetirement(choosenYear)
    
    let totalSavings = yearlySavings * yearsTillRetirement;
    
    let yearResult = new Intl.NumberFormat('da-DK',{style: 'currency', currency: 'DKK'}).format(yearlySavings);;
    let totalSavingsResult = new Intl.NumberFormat('da-DK',{style: 'currency', currency: 'DKK'}).format(totalSavings);

    let test = new Intl.NumberFormat('da-DK',{style: 'currency', currency: 'DKK'}).format(yearlySavings);
    console.log('test: ', test)

    this.yearResult.innerText = yearlySavings >= 1 ? `${yearResult}` : `Ingen besparelse`
    if (yearlySavings >= 1 && yearsTillRetirement == 0){
      this.totalResult.innerText =  `${yearResult}`
    }else{
      this.totalResult.innerText = totalSavings >= 1 ? `${totalSavingsResult}` : `Ingen besparelse`
    }

  }
}
